type Performer = { name?: string };

const isNonEmptyString = (value: unknown): value is string => {
  return typeof value === 'string' && value.trim().length > 0;
};

export const sanitizePerformers = (performers?: Performer[]): string[] => {
  if (!Array.isArray(performers)) {
    return [];
  }

  return performers.map((performer) => performer?.name?.trim()).filter(isNonEmptyString);
};

export const getPreviewPerformers = (
  headliners: string[],
  supporters: string[],
  threshold: number,
): { previewHeadliners: string[]; previewSupporters: string[] } => {
  const previewHeadliners = headliners.slice(0, threshold);
  const remainingSlots = Math.max(threshold - previewHeadliners.length, 0);
  const previewSupporters = supporters.slice(0, remainingSlots);

  return {
    previewHeadliners,
    previewSupporters,
  };
};
